const componentInstallmentIndex = component => {
  const index = Number(component?.installmentIndex);
  if (Number.isInteger(index) && index >= 0) return index;

  const labelMatch = String(component?.label || '').match(/^Installment\s+(\d+)$/i);
  return labelMatch ? Number(labelMatch[1]) - 1 : null;
};

const cents = amount => Math.round(Number(amount || 0) * 100);

export const installmentDiscountBreakdown = (discountQuote, installment) => {
  if (!discountQuote?.valid || !Array.isArray(discountQuote.components)) return null;

  const installmentIndexes = new Set(installment?.installmentIndexes || []);
  if (!installmentIndexes.size) return null;

  const totals = discountQuote.components.reduce(
    (result, component) => {
      if (!installmentIndexes.has(componentInstallmentIndex(component))) return result;

      const originalCents = cents(component?.originalAmount ?? component?.amount);
      const finalCents = cents(component?.finalAmount ?? component?.amount);

      return {
        originalCents: result.originalCents + originalCents,
        finalCents: result.finalCents + finalCents,
        matchedComponents: result.matchedComponents + 1,
      };
    },
    {originalCents: 0, finalCents: 0, matchedComponents: 0}
  );

  if (!totals.matchedComponents) return null;

  return {
    originalAmount: totals.originalCents / 100,
    discountAmount: Math.max(0, totals.originalCents - totals.finalCents) / 100,
    finalAmount: totals.finalCents / 100,
  };
};

export const currentInstallmentPaymentAmount = (discountQuote, displayInstallments) => {
  const bookingPayment = (displayInstallments || []).find(
    installment =>
      installment?.dueAtBooking === true || installment?.dt === 'At the time of booking'
  );

  return installmentDiscountBreakdown(discountQuote, bookingPayment)?.finalAmount ?? null;
};
